import http from "./HttpService";

var endpoint = `/reporting/analytics/cit-sci/`;

const headers = {};

const getScienceObjectives = async (year, filterId = -1, filterType = "objectives") => {
    const response = await http.get(`${endpoint}project-objectives/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getScienceEngagements = async (year, filterId = -1, filterType = "beneficiaries") => {
    const response = await http.get(`${endpoint}project-beneficiaries/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getParticipantsRolesDuring = async (year, filterId = -1, filterType = "during") => {
    const response = await http.get(`${endpoint}participant-roles/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getParticipantsRolesPost = async (year, filterId = -1, filterType = "post") => {
    const response = await http.get(`${endpoint}participant-roles/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getParticipantsConceptRoles = async (year, filterId = -1, filterType = "pre") => {
    const response = await http.get(`${endpoint}participant-roles/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getParticipantsDemographicsDisability = async (year, filterId = -1, filterType = "disability") => {
    const response = await http.get(`${endpoint}participant-demographics/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getParticipantsDemographicsGender = async (year, filterId = -1, filterType = "gender") => {
    const response = await http.get(`${endpoint}participant-demographics/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getParticipantsDemographicsRace = async (year, filterId = -1, filterType = "race") => {
    const response = await http.get(`${endpoint}participant-demographics/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getParticipantsDemographicsAgeRange = async (year, filterId = -1, filterType="age-range") => {
    const response = await http.get(`${endpoint}participant-demographics/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getParticipantsTypeDemographics = async (year, filterId = -1, filterType="type") => {
    const response = await http.get(`${endpoint}participant-demographics/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getProjectLocationProvince = async (year, filterId = -1, filterType = "province") => {
    const response = await http.get(`${endpoint}project-location/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getProjectLocationMunicipal = async (year, filterId = -1, filterType = "district") => {
    const response = await http.get(`${endpoint}project-location/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getParticipationProvince = async (year, filterId = -1, filterType = "province") => {
    const response = await http.get(`${endpoint}participant-location/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getParticipationMunicipal = async (year, filterId = -1, filterType = "district") => {
    const response = await http.get(`${endpoint}participant-location/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getProjectFundingSources = async (year, filterId = -1, filterType = "funding") => {
    const response = await http.get(`${endpoint}project-funding-sources/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getProjectDomainFields = async (year, filterId = -1, filterType = "grouped") => {
    const response = await http.get(`${endpoint}project-domain-fields/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getProjectBeneficiaries = async (year, filterId = -1, filterType = "beneficiaries") => {
    const response = await http.get(`${endpoint}project-beneficiaries/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getProjectScienceShop = async (year, filterId = -1, filterType = "scienceshop") => {
    const response = await http.get(`${endpoint}project-science-shop/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getProjectObjectives = async (year, filterId = -1, filterType = "objectives") => {
    const response = await http.get(`${endpoint}project-objectives/${year}/${filterId}?filterType=${filterType}`);
    return response;
};

const getProjectPartnerRole = async (year, filterId = -1) => {
    const response = await http.get(`${endpoint}project/partner/roles/${year}/${filterId}`);
    return response;
};

const getProjectPartnerResearch = async (year, filterId = -1) => {
    const response = await http.get(`${endpoint}project/partner/research/${year}/${filterId}`);
    return response;
};

const getProjectPartnerObjectives = async (year, filterId = -1) => {
    const response = await http.get(`${endpoint}project/partner/objectives/${year}/${filterId}`);
    return response;
};

const getProjectPartnerContributions = async (year, filterId = -1) => {
    const response = await http.get(`${endpoint}project/partner/contributions/${year}/${filterId}`);
    return response;
};

const getOrganisationalTotalProject = async (year, hostPartnerId = -1) => {
    const response = await http.get(`${endpoint}host-organisation-project-categories/${year}/${hostPartnerId}`);
    return response;
};

const getScienceFieldAnalytics = async (year, fieldId) => {
    const response = await http.get(`${endpoint}domain-field-count/${year}/${fieldId}`);
    return response;
};

const getYearRange = async () => {
    const response = await http.get(`${endpoint}year-range`);
    return response;
  };

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getScienceObjectives,
    getScienceEngagements,
    getParticipantsRolesDuring,
    getParticipantsRolesPost,
    getParticipantsConceptRoles,
    getParticipantsDemographicsDisability,
    getParticipantsDemographicsGender,
    getParticipantsDemographicsRace,
    getParticipantsDemographicsAgeRange,
    getParticipantsTypeDemographics,
    getProjectLocationProvince,
    getProjectLocationMunicipal,
    getParticipationProvince,
    getParticipationMunicipal,
    getProjectFundingSources,
    getProjectDomainFields,
    getProjectBeneficiaries,
    getProjectScienceShop,
    getProjectObjectives,
    getProjectPartnerRole,
    getProjectPartnerResearch,
    getProjectPartnerObjectives,
    getProjectPartnerContributions,
    getOrganisationalTotalProject,
    getScienceFieldAnalytics,
    getYearRange
}